import ButtonSave from "@View/components/buttons/ButtonSave";
import DefaultInput from "@View/components/formInputs/DefaultInput";
import ModalTittle from "@View/components/ModalTittle";
import ModalWrapper from "@View/components/ModalWrapper";
import React, { useCallback, useEffect, useState } from "react";
import getAPI from "@API/index";
import { useSelector } from "react-redux";
import { FetchOnceAutocompleteMultiple } from "@Components/form/control/FetchOnceAutocompleteMultiple";
import { useTranslation } from "react-i18next";

const EditGroupModal = ({
  group,
  customerId,
  open,
  handleOpen,
  handleClose,
  handleUpdate,
  groups = [],
}) => {
  const { t } = useTranslation();
  const [newData, setNewData] = React.useState();
  const customer = useSelector((state) => state.customer?.customer ?? {});

  React.useEffect(() => {
    setNewData({ ...group });
  }, [group]);

  const handleChange = (value, label) => {
    setNewData({ ...newData, [label]: value });
  };
  const [clientError, setClientError] = useState(false);
  const [clientVal, setClientVal] = useState([]);

  useEffect(() => {
    setClientVal(group.clients.map((i) => ({ id: i.id })));
  }, [group]);

  // Get all client IDs that are already in OTHER groups (not the current one)
  const clientsInOtherGroups = React.useMemo(() => {
    const ids = new Set();
    groups.forEach((g) => {
      // Skip the current group being edited
      if (g.id === group.id) return;
      (g.clients || []).forEach((client) => {
        ids.add(client.id);
      });
    });
    return ids;
  }, [groups, group.id]);

  const searchClients = useCallback(async () => {
    // Filter only clients that are not in any OTHER group
    return customer.clients
      .filter((client) => !clientsInOtherGroups.has(client.id))
      .map((client) => ({
        id: client.id,
        name: client.name,
      }));
  }, [customer, clientsInOtherGroups]);

  const handleClientChange = (newValue) => {
    setClientVal(newValue);
    // Clear error when user selects a value
    if (clientError && newValue.length > 0) {
      setClientError(false);
    }
  };

  if (!newData) {
    return null;
  }

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (clientVal.length === 0) {
      setClientError(true);
      return;
    }
    getAPI()
      .request({
        method: "put",
        url: `/api/Customer/${customer.id}/groups/${group.id}/update`,
        data: { ...newData, clients: clientVal },
        successText: "snackbar.success",
      })
      .then(() => {
        handleClose();
        handleUpdate();
      });
  };

  return (
    <ModalWrapper open={open} handleOpen={handleOpen} handleClose={handleClose}>
      <form onSubmit={(event) => handleClick(event)}>
        <ModalTittle>h1.EditGroup</ModalTittle>
        <DefaultInput
          value={newData.name}
          label="inputs.GroupName"
          onChange={(value) => handleChange(value, "name")}
        />
        <FetchOnceAutocompleteMultiple
          value={clientVal}
          id="ClientCapacity"
          label={t("ClientCapacity")}
          fetchOptions={searchClients}
          onChange={handleClientChange}
          error={clientError}
          helperText={clientError ? t("FieldRequired") : ""}
        />
        <ButtonSave>buttons.Save</ButtonSave>
      </form>
    </ModalWrapper>
  );
};

export default EditGroupModal;
